package modysy.model

import modysy.datastructures.Vector2

/** A rectangular, no-rotation inner field. */
class RectangularInnerField(topLeft: Vector2, bottomRight: Vector2)
    extends InnerField {
  private val minX = topLeft.x
  private val maxX = bottomRight.x
  private val minY = topLeft.y
  private val maxY = bottomRight.y

  override val borders: Seq[FixedShapeGameObject] = {
    val width = maxX - minX
    val height = maxY - minY

    val verticalBox = Box(2, height)
    val horizontalBox = Box(width, 2)
    val makeBorder = (box: Box, position: Vector2) =>
      new FixedShapeGameObject(
        new RigidBody(
          Transform.translate(position),
          Velocity.zero,
          Material(density = Double.PositiveInfinity, restitution = 1),
          box
        ),
        "purple"
    )

    Seq(
      makeBorder(horizontalBox, (minX + width.toDouble / 2, minY)),
      makeBorder(horizontalBox, (minX + width.toDouble / 2, maxY)),
      makeBorder(verticalBox, (minX, minY + height.toDouble / 2)),
      makeBorder(verticalBox, (maxX, minY + height.toDouble / 2))
    )
  }

  override def containsFully(pose: Transform, shape: Geometry): Boolean =
    shape match {
      case box: Box =>
        box.points.forall(point => {
          val globalPoint = pose * point
          minX <= globalPoint.x && globalPoint.x <= maxX && minY <= globalPoint.y && globalPoint.y <= maxY
        })
      case Circle(radius) =>
        minX <= pose.translation.x - radius && pose.translation.x + radius <= maxX &&
          minY <= pose.translation.y - radius && pose.translation.y + radius <= maxY
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/model/RectangularInnerField.scala